import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface Props {
  open: boolean
  disabled: boolean
  sameUser: boolean
  onSubmit: () => void
  onClose: () => void
}

export const ConfirmRevokeAccessModal = ({
  open,
  disabled,
  sameUser,
  onSubmit,
  onClose,
}: Props) => {
  if (!open) {
    return null
  }

  return (
    <Modal
      title={i18n.t('cronofy.calendar_syncs_list.revoke_access_modal.title')}
      description={
        sameUser
          ? i18n.t('cronofy.calendar_syncs_list.revoke_access_modal.same_user_description')
          : i18n.t('cronofy.calendar_syncs_list.revoke_access_modal.admin_description')
      }
      illustration="holidays-event-cancel"
      onClose={onClose}
      onSubmit={onSubmit}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button disabled={disabled} submit>
            {i18n.t('cronofy.calendar_syncs_list.revoke_access_modal.confirm_button')}
          </Button>
        </>
      }
    />
  )
}
